import React, { useId } from 'react'
import PropTypes from 'prop-types'

const HeadingIcon = React.forwardRef(function HeadingIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 4C6.55228 4 7 4.44772 7 5V19C7 19.5523 6.55228 20 6 20C5.44772 20 5 19.5523 5 19V5C5 4.44772 5.44772 4 6 4Z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 12C5 11.4477 5.44772 11 6 11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H6C5.44772 13 5 12.5523 5 12Z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 4C18.5523 4 19 4.44772 19 5V19C19 19.5523 18.5523 20 18 20C17.4477 20 17 19.5523 17 19V5C17 4.44772 17.4477 4 18 4Z"
      ></path>
    </svg>
  )
})

HeadingIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

HeadingIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default HeadingIcon
